define('controllers/consoleApi/serviceAccount.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('ServiceAccount', ['$scope', '$state', '$stateParams', '$rootScope', 'projectManageService','auiDialog',
        function ($scope, $state, $stateParams, $rootScope, projectManageService,auiDialog) {
            var Model = $scope.Model = {
                projectKey : $stateParams.projectKey
            };
            $scope.editSAK = editSAK;
            $scope.delSAK = delSAK;
            $scope.createSAK = createSAK;
            $scope.modSubAccountStatus = modSubAccountStatus;
            $scope.serviceStateFilter = {0:'启用', 1:'停用'};
            init();

            function init() {
                var param = {};
                if(Model.projectKey == '0'){
                    $state.go('credentials',{projectKey:0}, {reload: true});
                    return;
                }
                projectManageService.getProjectList().then(function (resp) {
                    if(resp && resp.resultCode == '0'){
                        if(resp && resp.projectInfoList.length>0){
                            var projectInfoList = resp.projectInfoList;
                            if(Model.projectKey != "0"){
                                projectManageService.getProjectInfo({projectKey:Model.projectKey}).then(function (data) {
                                    if(data && data.projectInfo){
                                        Model.myProject = data.projectInfo;
                                        projectManageService.setProjectKey(Model.myProject.projectKey);
                                        initSA();
                                        return;
                                    }
                                });
                            }else{
                                if(projectManageService.getProjectKey() !='0'){
                                    $state.go($state.current.name,{projectKey:projectManageService.getProjectKey()}, {reload: true});
                                }else{
                                    Model.myProject =projectInfoList[0];
                                    projectManageService.setProjectKey(Model.myProject.projectKey);
                                    Model.projectKey = Model.myProject.projectKey;
                                    initSA();
                                }
                            }
                        }else{
                            $state.go('myApi',{projectKey:0}, {reload: true});
                        }
                    }else{
                        $state.go('credentials',{projectKey:0}, {reload: true});
                    }
                });
            }

            function initSA(){
                projectManageService.getProjectCredentialList(Model.myProject.projectID, 3).then(function (resp) {
                    if(resp && resp.subAccountInfoList && resp.subAccountInfoList.length>0){
                        Model.subAccountInfoList = resp.subAccountInfoList;
                        Model.subAccountInfoList.forEach(function (serAccInfo) {
                            serAccInfo.publicKeyIDs =[];
                            if(serAccInfo.publicKeyList && serAccInfo.publicKeyList.length>0){
                                serAccInfo.publicKeyList.forEach(function (serKey) {
                                    serAccInfo.publicKeyIDs.push(serKey.publicKeyID);
                                })
                            }
                        });
                    }else{
                        Model.subAccountInfoList =[];
                    }
                });
            }

            //编辑serviceAccoutKey
            function editSAK(row){
                $state.go('addServiceAcccountKeys',{projectKey:Model.projectKey,clientID:row.clientID}, {reload: true});
            }
            //新建serviceAccoutKey
            function createSAK(row){
                $state.go('addServiceAcccountKeys',{projectKey:Model.projectKey,clientID:row.clientID}, {reload: true});
            }

            function delSAK(row){
                auiDialog.confirm("确定删除此服务帐号吗？","删除此服务帐号，会导致此服务帐号关联的API权限和资源都被删除，无法继续正常使用。",function () {
                    projectManageService.delClient(row.clientID,3).then(function(resp){
                        if (resp && resp.resultCode == 0) {
                            auiDialog.success('删除成功',function () {
                                init();
                            });
                        }
                    });
                });
            }
            //停用FastlaneTest服务帐号
            //停用服务帐号会阻止帐号向 API 进行身份验证，且可能会使资源无法正常使用该帐号。
            function modSubAccountStatus(row) {
                var onTips="确定启用该服务帐号吗？";
                var offTips = "停用服务帐号会阻止帐号向 API 进行身份验证，且可能会使资源无法正常使用该帐号。";
                var onSuccTips = "启用成功";
                var offSuccTips = "停用成功";
                auiDialog.confirm("修改服务帐号状态",((row.status == 1) ? onTips: offTips), function () {
                    projectManageService.modSubAccountStatus(row.clientID,(row.status == 1)?0:1).then(function(resp){
                        if (resp && resp.resultCode == 0) {
                            auiDialog.success((row.status == 1)?onSuccTips:offSuccTips);
                            init();
                        }
                    });
                });
            }

        }
    ]);
});

